import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../config/i18n';
import addIcon from '../../styles/icons/add-patient.svg';

const styles = {
  button: {
    height: 60,
    width: 60,
    float: 'right',
    borderRadius: '50%',
    border: '2px solid white',
    background: '#18bc9c',
  },
  addIcon: {
    height: '25px',
    width: '25px',
    paddingLeft: '3.5px',
  },
};

class AddPatientButton extends Component {
  render() {
    return (
      <button
        // className="btn btn-success"
        type="button"
        style={styles.button}
        onClick={this.props.onClick}
      >
        <img
          style={styles.addIcon}
          className="svg-icon"
          alt={i18n.t('add')}
          src={addIcon}
        />
      </button>
    );
  }
}

AddPatientButton.propTypes = {
  onClick: PropTypes.func,
};

AddPatientButton.defaultProps = {
  onClick: () => {},
};

export default AddPatientButton;



// WEBPACK FOOTER //
// ./src/components/shared/AddPatientButton.js